let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("8e146")).then(() => parcelRequire('aaute'));